<script>
    import { Day, Actions, Reaction } from './components'

    import { steps, cards } from './logic'
    import { step, backlog, week } from './stores'
    import { DAYS, BACKLOG_DEFAULT_STATE, WEEK_DEFAULT_STATE } from './config'

    import { rndAction, rndBool } from '@/helpers'

    import { UNIVERSAL_ENDING } from './config' 

    let currentStep = null
    let currentEnding = null

    const handleEnding = (endingData) => {
        currentEnding = endingData
        ym(88256496,'reachGoal','game_end')
    }

    const handleReaction = ({ detail: cardId }) => {
        const findStep = steps[steps[$step].next?.find((n) => steps[n].cardId === cardId)]

        if (findStep.reaction?.rndEnding && rndAction()){
            handleEnding(findStep.reaction?.rndEnding)

            return
        }

        if (findStep.reaction?.ending){
            if (Array.isArray(findStep.reaction?.ending)){
                const index = Number(rndBool())
                handleEnding(findStep.reaction?.ending[index])
            } else {
                handleEnding(findStep.reaction?.ending)
            }

            return
        }

        if ($week.items?.[4]?.length === 2){
            handleEnding({ 
                type: 'lose', 
                message: UNIVERSAL_ENDING 
            })

            return
        }

        if (findStep){
            currentStep = { ...findStep }
        }

        if (!currentStep?.reaction?.modalId){
            handleCloseReaction()
        }
    }

    const handleCloseReaction = () => {
        week.update((state) => ({ ...state, lastStep: { ...currentStep }}))
        const { actions } = ($week.lastStep?.reaction ?? {})
        currentStep = null

        if (actions){
            actions.forEach((action) => {
                const { type, data } = action

                if (type === 'addCards'){
                    let newCardsForAdding = []
                    data.forEach((newCardId) => {
                        if (!($backlog.includes(newCardId))){
                            newCardsForAdding.push(newCardId)
                        }
                    })
                    backlog.set([...$backlog, ...newCardsForAdding ])
                }

                if (type === 'removeCards'){
                    backlog.update((state) => state.filter((b) => !(data.includes(b))))
                }

                if (type === 'returnToBacklog') {
                    backlog.update((state) => [...state, $week.lastStep.cardId ])
                }
            });
        }
    }

    const handleRestartGame = () => {
        backlog.set(BACKLOG_DEFAULT_STATE)
        week.set(WEEK_DEFAULT_STATE)
        step.set('0')

        currentStep = null
        currentEnding = null
    }

    $:{
        // console.log('backlog')
        // console.log($backlog)
        // console.log('week')
        // console.log($week)
        // console.log('step')
        // console.log($step)
    }
</script>

<div class="game-inner">
    <div class="days-wrapper">
        {#each DAYS as day, i }
            <Day title={day} index={i} disabled={$week.currentDay !== i} />
        {/each}
    </div>

    <Actions on:reaction={handleReaction} />

    {#if currentStep?.reaction?.modalId}
    <!-- {#if true} -->
        <Reaction data={currentStep?.reaction} on:close={handleCloseReaction} />
    {/if}

    {#if currentEnding}
        <Reaction ending={currentEnding} on:close={handleRestartGame} />
    {/if}
</div>

<style lang="scss">
    .game-inner {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 706px;
        margin: 0 auto;
        padding: 32px 41px 47px 32px;
        background: #FFFFFF;
        box-shadow: 6px 4px 74px rgba(201, 100, 19, 0.14);
        border-radius: 15px;

        .days-wrapper {
            flex: 1;
            display: flex;
            justify-content: space-between;
        }
    }

    @media (max-width: 940px) {
        .game-inner {
            min-height: 460px;
            padding: 20px;
        }
    }

    @media (max-width: 720px) {
        .game-inner {
            height: auto;

            .days-wrapper {
                display: block;
            }
        }
    }
</style>